import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import About from "../../components/About";
import { AboutProvider } from "../../components/About/AboutContext";
import { AboutPageProvider } from "../../components/AboutPage/AboutPageContext";
import BioCardSection from "../../components/CardSection/BioCard";
import BoxCardSection from "../../components/CardSection/BoxCard";
import BoxCardDocSection from "../../components/CardSection/BoxCardDoc";
import { CardProvider } from "../../components/CardSection/CardContext";
import ShopCardSection from "../../components/CardSection/ShopCard";
import SmallCardSection from "../../components/CardSection/SmallCard";
import { CarouselProvider } from "../../components/Carousel/CarouselContext";
import CarouselQuoteContainer from "../../components/Carousel_quote";
import { CarouselQuoteProvider } from "../../components/Carousel_quote/CarouselQuoteContext";
import ContactSection from "../../components/Contact";
import Footer from "../../components/Footer";
import HeroHomeSection from "../../components/HeroSection/HeroHome";
import contactBgImg from "../../components/images/carousel3.jpg";
import fluteBgImg from "../../components/images/flute_background.jpg";
import bioBgImg from "../../components/images/home_bio_background.png";
import collectionBgImg from "../../components/images/home_collection_background2.jpg";
import phdBgImg from "../../components/images/home_doctoral_background.jpg";
import eventBgImg from "../../components/images/home_events_background.jpg";
import shopBgImg from "../../components/images/home_shop_background.jpg";
import mediaBgImg2 from "../../components/images/media.jpg";
import { InfoProvider } from "../../components/InfoSection/InfoContext";
import Instagram from "../../components/Instagram";
import { InstagramProvider } from "../../components/Instagram/InstagramContext";
import { LanguageProvider } from "../../components/LanguageContext";
import MediaSection from "../../components/MediaSection";
import { MediaProvider } from "../../components/MediaSection/MediaContext";
import Navbar from "../../components/NavbarHome";
import PartnersSection from "../../components/Partners";
import {
	FreespiritsAlbum,
	AntonioAlbum,
	ExplorationAlbum,
	GlowingAlbum,
	LapresMidiAlbum,
	QuartetAlbum,
	RomanticAlbum,
	TransformingAlbum,
  SleepOfReasonAlbum,
  DummyAlbum
} from "../../components/Player";
import { CardLaneContainer } from "../../components/Player/PlayerElements";
import SidebarHome from "../../components/SidebarHome";
import SpecialitiesSection from "../../components/Specialities";
import { SpecProvider } from "../../components/Specialities/SpecContext";
import SubscribeSection from "../../components/SubscribeNews";
import { OverflowContainer } from "./HomeElements";
ReactGA.initialize("UA-190810932-1");

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    ReactGA.pageview(window.location?.pathname + window.location.search);
  }, []);

  return (
    <LanguageProvider>
      <InstagramProvider>
        <AboutProvider>
          <AboutPageProvider>
            <InfoProvider>
              <CarouselProvider>
                <CarouselQuoteProvider>
                  <CardProvider>
                    <MediaProvider>
                      <SpecProvider>
                        <SidebarHome
                          isOpen={isOpen}
                          toggle={toggle}
                        ></SidebarHome>
                        <Navbar toggle={toggle}></Navbar>
                        <OverflowContainer>
                          <HeroHomeSection></HeroHomeSection>
                          <About></About>
                          <CarouselQuoteContainer></CarouselQuoteContainer>
                          <BoxCardDocSection
                            experience={false}
                            height="60vh"
                            value="-30rem"
                            left={false}
                            scroll={"doctoral"}
                            backgroundImage={phdBgImg}
                          ></BoxCardDocSection>
                          <CardLaneContainer>
                            <FreespiritsAlbum></FreespiritsAlbum>
						                <SleepOfReasonAlbum></SleepOfReasonAlbum>
						                <LapresMidiAlbum></LapresMidiAlbum>
                          </CardLaneContainer>
                          <CardLaneContainer>
                            <ExplorationAlbum></ExplorationAlbum>
                            <RomanticAlbum></RomanticAlbum>
						                <QuartetAlbum></QuartetAlbum>
                          </CardLaneContainer>
						              <CardLaneContainer>
                            <TransformingAlbum></TransformingAlbum>
                            <GlowingAlbum></GlowingAlbum>
                            <AntonioAlbum></AntonioAlbum>
                          </CardLaneContainer>
                          <SpecialitiesSection></SpecialitiesSection>
                          <SmallCardSection
                            scroll={"flute"}
                            backgroundImage={fluteBgImg}
                          ></SmallCardSection>
                          <BoxCardSection
                            experience={true}
                            height="60vh"
                            left={false}
                            scroll={"events"}
                            backgroundImage={eventBgImg}
                          ></BoxCardSection>
                          <MediaSection
                            scroll={"media"}
                            backgroundImage={mediaBgImg2}
                          ></MediaSection>
                          <Instagram></Instagram>
                          <BoxCardSection
                            height="40vh"
                            value="-50rem"
                            left={true}
                            scroll={"collection"}
                            backgroundImage={collectionBgImg}
                          ></BoxCardSection>
                          <BioCardSection
                            scroll={"bio"}
                            backgroundImage={bioBgImg}
                          ></BioCardSection>
                          <ShopCardSection
                            scroll={"shop"}
                            backgroundImage={shopBgImg}
                          ></ShopCardSection>
                          <ContactSection
                            green={true}
                            myContact={true}
                            myDescription={true}
                            bgcolor={"white"}
                            textcolor="black"
                          ></ContactSection>
                          <ContactSection
                            myContact={false}
                            myDescription={false}
                            bgcolor={contactBgImg}
                            textcolor="white"
                          ></ContactSection>
                          <SubscribeSection></SubscribeSection>
                          <PartnersSection></PartnersSection>
                        </OverflowContainer>
                        <Footer></Footer>
                      </SpecProvider>
                    </MediaProvider>
                  </CardProvider>
                </CarouselQuoteProvider>
              </CarouselProvider>
            </InfoProvider>
          </AboutPageProvider>
        </AboutProvider>
      </InstagramProvider>
    </LanguageProvider>
  );
};

export default Home;
// <SpecTextSection></SpecTextSection>{" "}
/*<BoxCardSection
                          height="40vh"
                          value="-20rem"
                          left={true}
                          scroll={"doctoral"}
                          backgroundImage={doctoralBgImg}
                        ></BoxCardSection>
                        
                        <DoctoralSection></DoctoralSection>
                        */
